import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { WorkspaceAssetType } from 'src/models/workspaceAssetType.interface';
import type { AppThunk } from 'src/store';
import { resetWorkspace } from 'src/store/extraActions';
import axiosCore from 'src/utils/axiosCore';

interface WorkspaceAssetTypeState {
  assetTypes: WorkspaceAssetType[];
  reload: boolean;
}

const initialState: WorkspaceAssetTypeState = {
  assetTypes: [],
  reload: false
};

const slice = createSlice({
  name: 'assetType',
  initialState,
  reducers: {
    getWorkspaceAssetTypes(
      state: WorkspaceAssetTypeState,
      action: PayloadAction<WorkspaceAssetType[]>
    ) {
      state.assetTypes = action.payload;
    }
  },
  extraReducers: {
    [resetWorkspace.type]() {
      return initialState;
    }
  }
});

export const reducer = slice.reducer;

export const getAssetTypes =
  (spaceId: string, spaceType: string): AppThunk =>
  async (dispatch) => {
    const response = await axiosCore.get<{ data: any }>(
      `/${spaceType}s/${spaceId}/asset-type`
    );
    dispatch(slice.actions.getWorkspaceAssetTypes(response.data.data));
  };

export default slice;
